import { type Variant } from '@jsmdg/tracking';
import { ProductType } from '../../shared/enums';
import { PurchaseType } from '../types/enums/purchaseType';
import { SellOption } from '../types/enums/sellOption';

function getPurchaseType(sellOption?: string): PurchaseType | undefined {
    if (!sellOption) {
        return undefined;
    }

    switch (sellOption) {
        case SellOption.VoucherOnly:
        case SellOption.TicketAndVoucher:
            return PurchaseType.Voucher;

        case SellOption.TicketOnly:
            return PurchaseType.Ticket;

        default:
            throw new Error(`Unknown sell option: ${sellOption}`);
    }
}

function getPurchaseVariantForTracking(
    type: string,
    purchaseType: PurchaseType | undefined,
): Variant {
    return type === ProductType.EXPERIENCE && purchaseType
        ? (`experience_${purchaseType}` as Variant)
        : (type.toLowerCase() as Variant);
}

export { getPurchaseType, getPurchaseVariantForTracking };
